// extracted by mini-css-extract-plugin
export default {"wrapper_content":"styles_wrapper_content__VjRpG","wrapper":"styles_wrapper__p8YBa","text":"styles_text__YHprM"};